export default "__VITE_ASSET__p56uK1TQ__"